import { Component } from "react";

import SortIcon from "@material-ui/icons/KeyboardArrowDown";

import _ from "underscore";

import { order } from "../services/sorting";
import PropTypes from "prop-types";

export default class Header extends Component {
  render() {
    let { tables, tableKey, actionColumnWidth, detailsRenderer, selectId } =
      this.props;
    let columns = tables[tableKey].columns;
    let columnOrdering = tables[tableKey].columnOrdering;
    let showDetails = !!detailsRenderer;
    let allowSelections = !!selectId;

    let renderColumns = _.filter(columns, (col) => {
      return col.visible !== false;
    });

    actionColumnWidth = actionColumnWidth ? actionColumnWidth + "px" : "350px";
    let actionColumn = undefined;
    if (renderColumns[renderColumns.length - 1].label == "Actions") {
      actionColumn = (
        <th
          className="order-table-cell order-table-cell--actions"
          style={{ position: "absolute", right: 0, padding: "3px 0" }}
          key="action-collumn"
        >
          <div
            style={{
              width: actionColumnWidth,
              textAlign: "center",
              display: "block",
            }}
          >
            Actions
          </div>
        </th>
      );
    }

    return (
      <tr>
        {allowSelections ? <th>Select</th> : undefined}
        {showDetails ? <th>Details</th> : undefined}

        {renderColumns.map((val, index) => {
          let actionClass = "";
          let divStyle = {};
          if (val.label == "Actions") {
            actionClass = " order-table-cell--action";
            divStyle = { width: actionColumnWidth };
          }

          let currentOrderForThisColumn = order.NONE;
          let sortingIcon;
          if (
            val.key == columnOrdering.key &&
            columnOrdering.order != order.NONE
          ) {
            currentOrderForThisColumn = columnOrdering.order;
            sortingIcon = (
              <span
                className={
                  "order-indicator order-indicator--" + columnOrdering.order
                }
              >
                <SortIcon />
              </span>
            );
          }

          let rowKeyForMapFunction = index + "-table-header-" + tableKey;
          let onClick;
          if (val.filter !== false) {
            onClick = this.props.order.bind(
              this,
              val.key,
              currentOrderForThisColumn,
              tableKey,
            );
          }
          let className = "order-table-cell" + actionClass;
          return (
            <th
              key={rowKeyForMapFunction}
              onClick={onClick}
              className={className}
            >
              <div style={divStyle}>{val.label}</div>
              {sortingIcon}
            </th>
          );
        })}

        {actionColumn}
      </tr>
    );
  }

  static propTypes = {
    tables: PropTypes.object.isRequired,
    actionColumnWidth: PropTypes.number,
    tableKey: PropTypes.string.isRequired,
    order: PropTypes.func,
    selectId: PropTypes.any,
    detailsRenderer: PropTypes.any,
  };
}
